const defaultTableConfig = {
  tdClass: 'text-black align-top',
  thClass: 'text-black text-capitalize py-1 font-semibold align-middle',
  class: 'bg-white',
  thStyle: {
    textTransform: 'capitalize',
    fontSize: '13px',
    color: 'black',
  },
}

export const fieldsProducts = [
  {
    key: 'checkbox',
    label: '',
    ...defaultTableConfig,
  },
  {
    key: 'product_name',
    label: 'Nama Produk',
    ...defaultTableConfig,
    thStyle: {
      ...defaultTableConfig.thStyle,
      minWidth: '400px',
    },
  },
  {
    key: 'product_variants',
    label: 'Variasi',
    ...defaultTableConfig,
  },
  {
    key: 'volume',
    label: 'Dimensi',
    ...defaultTableConfig,
  },
  {
    key: 'storage_type',
    label: 'Jenis Penyimpanan',
    ...defaultTableConfig,
    thStyle: {
      ...defaultTableConfig.thStyle,
      minWidth: '160px',
    },
    tdClass: 'text-black align-top min-h-[90px] flex items-center justify-center flex-col',
    formatter: value => {
      if (value === 1) {
        return 'Dry Storage'
      }
      if (value === 2) {
        return 'Cold Storage'
      }
      return '-'
    },
  },
  {
    key: 'packing_detail',
    label: 'Bahan Packing',
    ...defaultTableConfig,
    thStyle: {
      ...defaultTableConfig.thStyle,
      minWidth: '260px',
    },
  },
  {
    key: 'is_product_bonus',
    label: 'Produk Bonus',
    ...defaultTableConfig,
    thStyle: {
      ...defaultTableConfig.thStyle,
      width: '160px',
    },
  },
]

export const fieldsBundling = [
  {
    key: 'no',
    label: 'No',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize bg-white',
    tdClass: 'text-black',
  },
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize bg-white',
    tdClass: 'text-black',
  },
  {
    key: 'qty',
    label: 'Jumlah',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize text-center bg-white',
    tdClass: 'text-black text-center',
  },
]

export const fieldsVariantBundling = [
  {
    key: 'no',
    label: 'No',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize bg-white w-[30px]',
    tdClass: 'text-black',
  },
  {
    key: 'variant_name',
    label: 'Nama Varian',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize bg-white min-w-[200px]',
    tdClass: 'text-black',
  },
  {
    key: 'bundle_component',
    label: 'Relasi Produk',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize bg-white min-w-[250px]',
    tdClass: 'text-black',
  },
]
